document.addEventListener('DOMContentLoaded', function() {

  /* ============================================================
     I18N — textos vem de window.MAAT.strings, preenchido pelo Liquid
     em layout/theme.liquid (chaves maat.js.* dos locales). O portugues
     escrito aqui e so a reserva, caso o objeto nao exista.
     ============================================================ */
  function maatT(chave, pt) {
    var s = window.MAAT && window.MAAT.strings;
    return (s && s[chave]) || pt;
  }
  // Troca {n}, {name} etc. pelos valores passados.
  function maatTf(chave, pt, vars) {
    return maatT(chave, pt).replace(/\{(\w+)\}/g, function(m, v) {
      return vars && Object.prototype.hasOwnProperty.call(vars, v) ? String(vars[v]) : m;
    });
  }

  /* ============================================================
     SCROLL REVEAL — IntersectionObserver
     ============================================================ */
  function initScrollReveal() {
    var reveals = document.querySelectorAll('.maat-reveal, .maat-reveal-stagger');
    if (!reveals.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      reveals.forEach(function(el) { el.classList.add('revealed'); });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

    reveals.forEach(function(el) { observer.observe(el); });
  }
  initScrollReveal();

  /* ============================================================
     VIDEO AUTOPLAY — toca ao entrar na tela
     (autoplay nem sempre dispara em video fora do fold; pausado e
     sem poster, ele fica em branco -> deixava um vao no PDP)
     ============================================================ */
  (function initAutoplayVideos() {
    var vids = document.querySelectorAll('video[autoplay]');
    if (!vids.length) return;

    // a11y A12 (2.2.2): com prefers-reduced-motion o video nao toca sozinho,
    // e quem pausou pelo botao nao ve o video voltar ao rolar a pagina.
    var semMovimento = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    vids.forEach(function(v) {
      if (semMovimento) {
        v.removeAttribute('autoplay');
        v.pause();
        v.setAttribute('data-maat-pausado', '1');
        // Parado e sem poster, alguns navegadores (Safari) deixam o quadro em
        // branco: pede o primeiro quadro para ele aparecer como imagem.
        v.preload = 'auto';
        v.addEventListener('loadeddata', function() {
          if (v.paused && v.currentTime === 0) v.currentTime = 0.01;
        }, { once: true });
      }
    });

    // Botao pausar/tocar sobre o video (aria-controls aponta o id do video).
    function syncBotao(btn, v) {
      var pausado = v.paused;
      btn.setAttribute('aria-label', pausado ? maatT('video_play', 'Tocar vídeo') : maatT('video_pause', 'Pausar vídeo'));
      btn.classList.toggle('is-paused', pausado);
    }
    document.querySelectorAll('.maat-video-toggle').forEach(function(btn) {
      var v = document.getElementById(btn.getAttribute('aria-controls'));
      if (!v) return;
      syncBotao(btn, v);
      v.addEventListener('play', function() { syncBotao(btn, v); });
      v.addEventListener('pause', function() { syncBotao(btn, v); });
      btn.addEventListener('click', function() {
        if (v.paused) {
          v.removeAttribute('data-maat-pausado');
          var p = v.play(); if (p && p.catch) p.catch(function(){});
        } else {
          v.setAttribute('data-maat-pausado', '1');
          v.pause();
        }
      });
    });

    function tryPlay(v) {
      if (v.hasAttribute('data-maat-pausado')) return;
      var p = v.play(); if (p && p.catch) p.catch(function(){});
    }
    if (semMovimento) return;
    if (!('IntersectionObserver' in window)) {
      vids.forEach(tryPlay);
      return;
    }
    var vo = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) tryPlay(e.target);
        else e.target.pause();
      });
    }, { threshold: 0.25 });
    vids.forEach(function(v) { vo.observe(v); });
  })();

  /* ============================================================
     ANNOUNCEMENT BAR HEIGHT
     ============================================================ */
  var announcement = document.querySelector('.maat-announcement');
  function updateAnnouncementHeight() {
    if (announcement) {
      document.documentElement.style.setProperty(
        '--maat-announcement-h',
        announcement.offsetHeight + 'px'
      );
    }
  }
  updateAnnouncementHeight();
  window.addEventListener('resize', updateAnnouncementHeight);

  /* ============================================================
     HEADER SCROLL EFFECT
     ============================================================ */
  var header = document.querySelector('.maat-header');
  if (header) {
    window.addEventListener('scroll', function() {
      header.classList.toggle('scrolled', window.scrollY > 50);
    }, { passive: true });
  }

  /* ============================================================
     MOBILE MENU — SLIDE LATERAL
     ============================================================ */
  var mobileToggle = document.querySelector('.maat-mobile-toggle');
  var mobileMenu = document.querySelector('.maat-mobile-menu');
  var mobileOverlay = document.querySelector('.maat-mobile-overlay');
  var mobileClose = document.querySelector('.maat-mobile-close');

  var savedScrollY = 0;

  /* Dialogos (menu mobile e gaveta), auditoria a11y A01-A03.
     Fechado: atributo inert (sai da ordem do Tab e do leitor de tela).
     Aberto: Tab e Shift+Tab circulam dentro do dialogo. */
  function focaveisDe(container) {
    return Array.prototype.filter.call(
      container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'),
      function(el) { return el.getClientRects().length > 0; }
    );
  }

  function dialogoAberto() {
    return document.querySelector('.maat-cart-drawer.active') ||
      document.querySelector('.maat-mobile-menu.active');
  }

  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Tab') return;
    var dialogo = dialogoAberto();
    if (!dialogo) return;
    var focaveis = focaveisDe(dialogo);
    if (!focaveis.length) { e.preventDefault(); return; }
    var primeiro = focaveis[0];
    var ultimo = focaveis[focaveis.length - 1];
    var atual = document.activeElement;
    if (!dialogo.contains(atual)) {
      e.preventDefault();
      (e.shiftKey ? ultimo : primeiro).focus();
    } else if (e.shiftKey && (atual === primeiro || focaveis.indexOf(atual) === -1)) {
      e.preventDefault();
      ultimo.focus();
    } else if (!e.shiftKey && atual === ultimo) {
      e.preventDefault();
      primeiro.focus();
    }
  });

  function openMobileMenu(viaKeyboard) {
    if (!mobileMenu || !mobileOverlay) return;
    savedScrollY = window.scrollY || window.pageYOffset || 0;
    mobileMenu.classList.add('active');
    mobileMenu.setAttribute('aria-hidden', 'false');
    mobileMenu.removeAttribute('inert');
    mobileOverlay.classList.add('active');
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'true');
    // Scroll-lock robusto: no iOS Safari overflow:hidden no body NAO trava o scroll.
    // Fixar o body preservando a posicao e a unica forma confiavel.
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + savedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    // So mover o foco quando aberto via teclado: foco programatico no toque
    // dispara o anel :focus-visible (quadrado laranja) no iOS.
    if (viaKeyboard) {
      var firstLink = mobileMenu.querySelector('.maat-mobile-menu-links a');
      if (firstLink) firstLink.focus();
    }
  }

  function closeMobileMenu(viaKeyboard) {
    if (!mobileMenu || !mobileOverlay) return;
    // Foco que estava dentro do menu nao pode ficar num elemento inert.
    var focoDentro = mobileMenu.contains(document.activeElement);
    mobileMenu.classList.remove('active');
    mobileMenu.setAttribute('aria-hidden', 'true');
    mobileMenu.setAttribute('inert', '');
    mobileOverlay.classList.remove('active');
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, savedScrollY);
    if ((viaKeyboard || focoDentro) && mobileToggle) mobileToggle.focus({ preventScroll: true });
  }

  // e.detail === 0 indica ativacao por teclado (Enter/Espaco); >0 e mouse/toque.
  if (mobileToggle) mobileToggle.addEventListener('click', function(e) { openMobileMenu(e.detail === 0); });
  if (mobileClose) mobileClose.addEventListener('click', function(e) { closeMobileMenu(e.detail === 0); });
  if (mobileOverlay) mobileOverlay.addEventListener('click', function() { closeMobileMenu(false); });

  // Fallback robusto: fecha ao tocar fora do menu mesmo que o overlay nao capture
  // o toque (ex.: pointer-events do overlay sobrescrito). O toque "atravessa" o
  // overlay e chega no document; aqui checamos se foi fora do menu.
  document.addEventListener('click', function(e) {
    if (!mobileMenu || !mobileMenu.classList.contains('active')) return;
    if (mobileMenu.contains(e.target)) return;
    if (mobileToggle && mobileToggle.contains(e.target)) return;
    closeMobileMenu(false);
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('active')) {
      closeMobileMenu(true);
    }
  });

  if (mobileMenu) {
    mobileMenu.querySelectorAll('.maat-mobile-menu-links a').forEach(function(link) {
      link.addEventListener('click', function() { closeMobileMenu(false); });
    });
  }

  /* ============================================================
     FAQ ACCORDION — Estilo Brez (multiplos abertos)
     ============================================================ */
  document.querySelectorAll('.faq-maat__toggle').forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      var block = toggle.closest('.faq-maat__block');
      var content = block.querySelector('.faq-maat__content');
      var isOpen = block.classList.contains('open');
      if (isOpen) {
        block.classList.remove('open');
        content.style.maxHeight = '';
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        block.classList.add('open');
        content.style.maxHeight = content.scrollHeight + 'px';
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ============================================================
     PDP — DETAIL ACCORDION
     ============================================================ */
  document.querySelectorAll('.maat-pdp-detail-item').forEach(function(item) {
    var trigger = item.querySelector('.maat-pdp-detail-trigger');
    if (trigger) {
      trigger.addEventListener('click', function() {
        var wasOpen = item.classList.contains('open');
        document.querySelectorAll('.maat-pdp-detail-item').forEach(function(i) {
          i.classList.remove('open');
          var btn = i.querySelector('.maat-pdp-detail-trigger');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          item.classList.add('open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    }
  });

  /* ============================================================
     PDP — GALERIA
     ============================================================ */
  var mainImg = document.getElementById('maat-pdp-main-img');
  document.querySelectorAll('.maat-pdp-thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var src = thumb.getAttribute('data-img-src');
      if (mainImg && src) {
        mainImg.src = src;
        document.querySelectorAll('.maat-pdp-thumb').forEach(function(t) {
          t.classList.remove('active');
        });
        thumb.classList.add('active');
      }
    });
  });

  /* ============================================================
     PDP — QUANTIDADE (+/-)
     ============================================================ */
  var qtyInput = document.getElementById('maat-qty');
  var qtyMinus = document.querySelector('.maat-qty-minus');
  var qtyPlus = document.querySelector('.maat-qty-plus');

  if (qtyInput && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener('click', function() {
      var val = parseInt(qtyInput.value) || 1;
      if (val > 1) qtyInput.value = val - 1;
    });
    qtyPlus.addEventListener('click', function() {
      var val = parseInt(qtyInput.value) || 1;
      var max = parseInt(qtyInput.max) || 99;
      if (val < max) qtyInput.value = val + 1;
    });
  }

  /* PDP hint de frete gratis por valor REMOVIDO (2026-07-05, ADR-0004):
     a regra agora e "frete gratis na 1a compra", nao por valor >=R$299. */

  /* ============================================================
     GAVETA DO CARRINHO (MINI-CART)
     ------------------------------------------------------------
     Por que existe: a v1.3.0 (ADR-0011) tirou o /cart do caminho de
     compra mandando o cliente direto pro /checkout. Mas o resumo do
     checkout do Shopify e SOMENTE LEITURA fora do plano Plus — nao da
     pra mudar quantidade, remover nem adicionar item la dentro. A
     gaveta devolve esse controle ANTES do checkout sem reintroduzir
     uma etapa de pagina (e sobreposicao, nao navegacao).

     Markup em snippets/maat-cart-drawer.liquid (casca vazia); o
     conteudo e montado aqui a partir de /cart.js. Nao usa a
     cart-drawer do Dawn de proposito — o CSS dela carrega depois do
     maat-theme.css e foi a causa do incidente da v1.2.4.
     ============================================================ */
  var cartDrawer = document.querySelector('.maat-cart-drawer');
  var cartOverlay = document.querySelector('.maat-cart-overlay');
  var cartDrawerSavedScrollY = 0;
  var cartDrawerTrigger = null;

  function maatMoney(cents) {
    // Sempre no formato brasileiro ("R$ 74,00"), igual ao money do Liquid na
    // PDP: a loja vende so em BRL e so no Brasil. Com o lang da pagina, o /es
    // mostrava "74,00 BRL" na gaveta (QA da i18n Fase 1).
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  // item.url do /cart.js vem sem o prefixo do idioma (/es, /en): prefixa com
  // Shopify.routes.root para o link da gaveta nao voltar ao portugues.
  function maatUrlIdioma(url) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (!url || root === '/' || url.charAt(0) !== '/' || url.indexOf(root) === 0) return url;
    return root.replace(/\/$/, '') + url;
  }

  function maatThumb(url, px) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + px;
  }

  function maatEscape(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function(c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function updateCartBadge(cart) {
    var cartIcon = document.querySelector('.maat-cart-icon');
    if (!cartIcon) return;
    var badge = cartIcon.querySelector('.maat-cart-badge');
    // A26: o aria-label do link substitui o selo, entao a quantidade vai nele.
    var n = cart.item_count || 0;
    cartIcon.setAttribute('aria-label', n === 0 ? maatT('cart_empty', 'Carrinho vazio') : (n === 1 ? maatT('cart_one', 'Carrinho, 1 item') : maatTf('cart_many', 'Carrinho, {n} itens', { n: n })));
    if (cart.item_count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'maat-cart-badge';
        cartIcon.appendChild(badge);
      }
      badge.textContent = cart.item_count;
      badge.style.display = 'flex';
      badge.classList.remove('updated');
      void badge.offsetWidth;
      badge.classList.add('updated');
    } else if (badge) {
      badge.style.display = 'none';
    }
    var flutuante = document.querySelector('.maat-cart-float');
    if (flutuante) {
      flutuante.hidden = n === 0;
      flutuante.setAttribute('aria-label', cartIcon.getAttribute('aria-label'));
      var cont = flutuante.querySelector('.maat-cart-float-count');
      if (cont) cont.textContent = n;
    }
  }

  var ICONE_MENOS = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><line x1="3" y1="7" x2="11" y2="7"/></svg>';
  var ICONE_MAIS = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><line x1="3" y1="7" x2="11" y2="7"/><line x1="7" y1="3" x2="7" y2="11"/></svg>';

  function renderCartDrawer(cart) {
    if (!cartDrawer) return;
    updateCartBadge(cart);

    var list = cartDrawer.querySelector('.maat-cart-drawer-items');
    var empty = cartDrawer.querySelector('.maat-cart-drawer-empty');
    var footer = cartDrawer.querySelector('.maat-cart-drawer-footer');
    var total = cartDrawer.querySelector('.maat-cart-drawer-total');
    var descontoRow = cartDrawer.querySelector('.maat-cart-drawer-desconto');
    var descontoVal = cartDrawer.querySelector('.maat-cart-drawer-desconto-valor');
    if (!list) return;

    // a11y A14: o innerHTML recria os botoes e o foco caia no <body>.
    // Guarda qual controle estava focado (item + acao) para devolver depois.
    var focoAnterior = null;
    var ativo = document.activeElement;
    if (ativo && list.contains(ativo)) {
      var liAtivo = ativo.closest('.maat-cart-drawer-item');
      if (liAtivo) {
        focoAnterior = {
          key: liAtivo.getAttribute('data-key'),
          acao: ativo.getAttribute('data-acao') ||
            (ativo.classList.contains('maat-cart-drawer-item-remover') ? 'remover' : null),
          indice: Array.prototype.indexOf.call(list.children, liAtivo)
        };
      }
    }

    function controleDe(li, acao) {
      if (!li) return null;
      if (acao === 'mais' || acao === 'menos') {
        return li.querySelector('[data-acao="' + acao + '"]');
      }
      return li.querySelector('.maat-cart-drawer-item-remover');
    }

    function restaurarFoco() {
      if (!focoAnterior || !cartDrawer.classList.contains('active')) return;
      var itens = list.querySelectorAll('.maat-cart-drawer-item');
      var mesmo = null;
      Array.prototype.forEach.call(itens, function(li) {
        if (li.getAttribute('data-key') === focoAnterior.key) mesmo = li;
      });
      // Item sumiu (removido ou zerado): vai para o item que ocupou o lugar dele.
      var alvo = controleDe(mesmo || itens[focoAnterior.indice] || itens[itens.length - 1], focoAnterior.acao);
      if (!alvo) alvo = cartDrawer.querySelector('.maat-cart-drawer-title');
      if (alvo) alvo.focus({ preventScroll: true });
    }

    if (!cart.items || !cart.items.length) {
      list.innerHTML = '';
      if (empty) empty.classList.remove('is-hidden');
      if (footer) footer.classList.add('is-hidden');
      maatUpsellRender(cartDrawer.querySelector('[data-maat-upsell]'), cart);
      restaurarFoco();
      return;
    }
    if (empty) empty.classList.add('is-hidden');
    if (footer) footer.classList.remove('is-hidden');

    list.innerHTML = cart.items.map(function(item) {
      var img = (item.featured_image && item.featured_image.url) || item.image || '';
      var alt = (item.featured_image && item.featured_image.alt) || item.product_title || '';
      var nome = item.product_title || item.title || '';
      var variante = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';

      return '<li class="maat-cart-drawer-item" data-key="' + maatEscape(item.key) + '">' +
          '<div class="maat-cart-drawer-item-foto">' +
            (img ? '<img src="' + maatEscape(maatThumb(img, 160)) + '" alt="' + maatEscape(alt) + '" width="72" height="72" loading="lazy">' : '') +
          '</div>' +
          '<div class="maat-cart-drawer-item-info">' +
            '<a class="maat-cart-drawer-item-nome" href="' + maatEscape(maatUrlIdioma(item.url)) + '">' + maatEscape(nome) + '</a>' +
            (variante ? '<p class="maat-cart-drawer-item-variante">' + maatEscape(variante) + '</p>' : '') +
            '<div class="maat-cart-drawer-item-linha">' +
              '<div class="maat-cart-drawer-qty">' +
                '<button type="button" data-acao="menos" aria-label="' + maatEscape(maatTf('qty_decrease_item', 'Diminuir quantidade de {name}', { name: nome })) + '">' + ICONE_MENOS + '</button>' +
                '<span class="maat-cart-drawer-qty-valor">' + item.quantity + '</span>' +
                '<button type="button" data-acao="mais" aria-label="' + maatEscape(maatTf('qty_increase_item', 'Aumentar quantidade de {name}', { name: nome })) + '">' + ICONE_MAIS + '</button>' +
              '</div>' +
              '<span class="maat-cart-drawer-item-preco">' + maatMoney(item.final_line_price) + '</span>' +
            '</div>' +
            '<button type="button" class="maat-cart-drawer-item-remover" aria-label="' + maatEscape(maatTf('remove_item', 'Remover {name} do carrinho', { name: nome })) + '">' + maatEscape(maatT('remove', 'Remover')) + '</button>' +
          '</div>' +
        '</li>';
    }).join('');

    // Descontos automaticos (3%/4%/5% por volume) ja vem aplicados no
    // total_price do /cart.js — mostrar em vez de esconder ate o checkout.
    if (descontoRow && descontoVal) {
      if (cart.total_discount > 0) {
        descontoVal.textContent = '− ' + maatMoney(cart.total_discount);
        descontoRow.classList.remove('is-hidden');
      } else {
        descontoRow.classList.add('is-hidden');
      }
    }

    if (total) total.textContent = maatMoney(cart.total_price);
    restaurarFoco();
    maatUpsellRender(cartDrawer.querySelector('[data-maat-upsell]'), cart);
  }

  /* ============================================================
     UPSELL DE VOLUME (ADR-0024) — gaveta e /cart
     Tudo calculado: faixas = espelho dos descontos automaticos do admin
     (data-maat-tiers no snippet da gaveta), precos = variantes reais de
     /products/<handle>.js, desconto aplicado = o que o /cart.js devolve.
     Nunca mostra oferta que nao deixe a lata mais barata.
     ============================================================ */
  var upsellCfgEl = cartDrawer || document.querySelector('[data-maat-tiers]');
  var UPSELL_HANDLE = (upsellCfgEl && upsellCfgEl.getAttribute('data-maat-produto')) || 'mate-com-limao-organico';
  var UPSELL_TIERS = ((upsellCfgEl && upsellCfgEl.getAttribute('data-maat-tiers')) || '3:3,4:4,5:5')
    .split(',').map(function(p) { var a = p.split(':'); return { min: parseInt(a[0], 10), pct: parseFloat(a[1]) }; })
    .filter(function(t) { return t.min > 0 && t.pct > 0; })
    .sort(function(a, b) { return a.min - b.min; });
  var upsellProdutoPromise = null;

  function upsellProduto() {
    if (!upsellProdutoPromise) {
      upsellProdutoPromise = fetch('/products/' + UPSELL_HANDLE + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r) { return r.ok ? r.json() : null; })
        .catch(function() { return null; });
    }
    return upsellProdutoPromise;
  }

  function upsellLatas(v) {
    var n = parseInt(String((v && (v.title || v.option1)) || ''), 10);
    return n > 0 ? n : 0;
  }

  function upsellPct(unidades) {
    var pct = 0;
    UPSELL_TIERS.forEach(function(t) { if (unidades >= t.min) pct = t.pct; });
    return pct;
  }

  function upsellCalcular(cart, produto) {
    var itens = (cart.items || []).filter(function(i) { return i.handle === UPSELL_HANDLE; });
    if (!itens.length || !produto || !produto.variants) return null;
    var variantes = produto.variants.filter(function(v) { return v.available && upsellLatas(v) > 0; })
      .sort(function(a, b) { return upsellLatas(a) - upsellLatas(b); });
    if (!variantes.length) return null;
    var caixa = null;
    variantes.forEach(function(v) { if (upsellLatas(v) === 12) caixa = v; });
    caixa = caixa || variantes[variantes.length - 1];
    var pack = variantes[0];

    var unidades = 0, latas = 0, base = 0, final = 0, qtdPack = 0, qtdCaixa = 0;
    itens.forEach(function(i) {
      var l = parseInt(String(i.variant_title || ''), 10) || 0;
      unidades += i.quantity;
      latas += l * i.quantity;
      base += i.original_line_price;
      final += i.final_line_price;
      if (i.variant_id === pack.id) qtdPack += i.quantity;
      if (i.variant_id === caixa.id) qtdCaixa += i.quantity;
    });
    if (!latas) return null;

    var r = { porLata: final / latas, pctAtual: upsellPct(unidades), ofertas: [] };

    // 1) Troca de packs por caixa (mesmas latas, menos dinheiro)
    var packsPorCaixa = upsellLatas(caixa) / upsellLatas(pack);
    if (pack.id !== caixa.id && packsPorCaixa === Math.floor(packsPorCaixa) && qtdPack >= packsPorCaixa) {
      var k = Math.floor(qtdPack / packsPorCaixa);
      var u2 = unidades - k * packsPorCaixa + k;
      var b2 = base - k * packsPorCaixa * pack.price + k * caixa.price;
      var f2 = Math.round(b2 * (1 - upsellPct(u2) / 100));
      var economia = final - f2;
      if (economia >= 100) {
        r.ofertas.push({
          tipo: 'troca', k: k, packsPorCaixa: packsPorCaixa, economia: economia,
          updates: [[pack.id, qtdPack - k * packsPorCaixa], [caixa.id, qtdCaixa + k]]
        });
      }
    }

    // 2) Proxima faixa de desconto por volume, completando com caixas
    var prox = null;
    UPSELL_TIERS.forEach(function(t) { if (!prox && t.min > unidades) prox = t; });
    if (prox) {
      var falta = prox.min - unidades;
      var b3 = base + falta * caixa.price;
      var porLata3 = Math.round(b3 * (1 - prox.pct / 100)) / (latas + falta * upsellLatas(caixa));
      if (porLata3 < r.porLata) {
        r.ofertas.push({ tipo: 'faixa', falta: falta, pct: prox.pct, porLata: porLata3, caixaId: caixa.id, latasCaixa: upsellLatas(caixa) });
      }
    } else if (r.pctAtual > 0) {
      r.topo = true;
    }
    return r;
  }

  function maatPct(n) { return String(n).replace('.', ',') + '%'; }

  function maatUpsellRender(el, cart, aposAcao) {
    if (!el) return;
    upsellProduto().then(function(produto) {
      var r = upsellCalcular(cart, produto);
      if (!r) { el.classList.add('is-hidden'); el.innerHTML = ''; return; }
      var html = '<p class="maat-upsell-lata">' +
        maatEscape(maatT('upsell_per_can', 'Hoje cada lata sai por')) + ' <strong>' + maatMoney(Math.round(r.porLata)) + '</strong>' +
        (r.pctAtual > 0 ? ' <span class="maat-upsell-pill">' + maatEscape(maatTf('upsell_applied', '{pct} off aplicado', { pct: maatPct(r.pctAtual) })) + '</span>' : '') +
        '</p>';
      r.ofertas.forEach(function(o) {
        if (o.tipo === 'troca') {
          html += '<div class="maat-upsell-oferta">' +
            '<p>' + maatEscape(maatTf('upsell_swap', 'Troca {packs} packs de 4 por {k} caixa de 12: as mesmas latas, {valor} a menos.', {
              packs: o.k * o.packsPorCaixa, k: o.k, valor: maatMoney(o.economia) })) + '</p>' +
            '<button type="button" class="maat-upsell-btn" data-upsell-updates="' + maatEscape(JSON.stringify(o.updates)) + '">' +
              maatEscape(maatT('upsell_swap_btn', 'Trocar pela caixa')) + '</button>' +
          '</div>';
        } else {
          html += '<div class="maat-upsell-oferta">' +
            '<p>' + maatEscape(o.falta === 1
              ? maatTf('upsell_tier_one', 'Mais 1 caixa de {latas} e o desconto sobe pra {pct}: cada lata sai por {valor}.', { latas: o.latasCaixa, pct: maatPct(o.pct), valor: maatMoney(Math.round(o.porLata)) })
              : maatTf('upsell_tier_many', 'Mais {n} caixas de {latas} e o desconto sobe pra {pct}: cada lata sai por {valor}.', { n: o.falta, latas: o.latasCaixa, pct: maatPct(o.pct), valor: maatMoney(Math.round(o.porLata)) })) + '</p>' +
            '<button type="button" class="maat-upsell-btn" data-upsell-add="' + o.caixaId + '" data-upsell-qty="' + o.falta + '">' +
              maatEscape(o.falta === 1 ? maatT('upsell_add_one', 'Adicionar 1 caixa') : maatTf('upsell_add_many', 'Adicionar {n} caixas', { n: o.falta })) + '</button>' +
          '</div>';
        }
      });
      if (r.topo) {
        html += '<p class="maat-upsell-topo">' + maatEscape(maatTf('upsell_top', 'Você já tem o maior desconto por volume: {pct}.', { pct: maatPct(r.pctAtual) })) + '</p>';
      }
      el.innerHTML = html;
      el.classList.remove('is-hidden');
      el.onclick = function(e) {
        var btn = e.target.closest ? e.target.closest('.maat-upsell-btn') : null;
        if (!btn) return;
        e.stopPropagation();
        btn.disabled = true;
        var req;
        if (btn.hasAttribute('data-upsell-add')) {
          req = fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-upsell-add'), 10), quantity: parseInt(btn.getAttribute('data-upsell-qty'), 10) }] })
          });
        } else {
          var updates = {};
          JSON.parse(btn.getAttribute('data-upsell-updates')).forEach(function(u) { updates[u[0]] = u[1]; });
          req = fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ updates: updates })
          });
        }
        req.then(function(res) {
          if (!res.ok) return res.json().then(function(er) { throw new Error(er.description || er.message || maatT('cart_update_error', 'Não foi possível atualizar o carrinho')); });
          return fetchCart();
        })
        .then(function(novo) {
          if (aposAcao) { aposAcao(novo); return; }
          renderCartDrawer(novo);
        })
        .catch(function(er) {
          btn.disabled = false;
          var err = cartDrawer ? cartDrawer.querySelector('.maat-cart-drawer-error') : null;
          if (err && cartDrawer.contains(el)) { err.textContent = er.message; err.classList.remove('is-hidden'); }
          else { window.alert(er.message); }
        });
      };
    });
  }

  // Pagina /cart: o bloco fica FORA do .js-contents (que o maat-cart-fix.js
  // troca pela Section Rendering API). Depois de uma acao do upsell recarrega
  // a pagina: e o mesmo estado do servidor, sem re-render parcial.
  var cartPageFooter = document.querySelector('body.template-cart .cart__blocks');
  if (cartPageFooter) {
    var upsellPagina = document.createElement('div');
    upsellPagina.className = 'maat-upsell maat-upsell--pagina is-hidden';
    upsellPagina.setAttribute('data-maat-upsell', '');
    cartPageFooter.parentNode.insertBefore(upsellPagina, cartPageFooter);
    var recarregar = function() { window.location.reload(); };
    var atualizarUpsellPagina = function() {
      fetchCart().then(function(c) { maatUpsellRender(upsellPagina, c, recarregar); }).catch(function() {});
    };
    atualizarUpsellPagina();
    document.addEventListener('maat:cart-changed', atualizarUpsellPagina);
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); });
  }

  function changeCartLine(key, quantity, itemEl) {
    var err = cartDrawer ? cartDrawer.querySelector('.maat-cart-drawer-error') : null;
    var live = cartDrawer ? cartDrawer.querySelector('.maat-cart-drawer-live') : null;
    if (err) err.classList.add('is-hidden');
    if (itemEl) itemEl.classList.add('is-updating');

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(res) {
      if (!res.ok) {
        return res.json().then(function(e) {
          throw new Error(e.description || e.message || maatT('cart_update_error', 'Não foi possível atualizar o carrinho'));
        });
      }
      return res.json();
    })
    .then(function(cart) {
      renderCartDrawer(cart);
      if (live) {
        live.textContent = cart.item_count === 0
          ? maatT('cart_empty_live', 'Carrinho vazio.')
          : (cart.item_count === 1
            ? maatT('cart_updated_one', 'Carrinho atualizado: 1 item.')
            : maatTf('cart_updated_many', 'Carrinho atualizado: {n} itens.', { n: cart.item_count }));
      }
    })
    .catch(function(e) {
      if (itemEl) itemEl.classList.remove('is-updating');
      if (err) {
        err.textContent = e.message;
        err.classList.remove('is-hidden');
      }
    });
  }

  function openCartDrawer(viaKeyboard) {
    if (!cartDrawer || !cartOverlay) return;
    // Fecha o menu mobile antes: os dois usam o mesmo scroll-lock de body fixo.
    if (mobileMenu && mobileMenu.classList.contains('active')) closeMobileMenu(false);

    cartDrawerSavedScrollY = window.scrollY || window.pageYOffset || 0;
    cartDrawer.classList.add('active');
    cartDrawer.setAttribute('aria-hidden', 'false');
    cartDrawer.removeAttribute('inert');
    cartOverlay.classList.add('active');
    // Mesmo scroll-lock do menu mobile: no iOS Safari, overflow:hidden no body
    // nao trava o scroll — fixar o body preservando a posicao e o unico jeito.
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + cartDrawerSavedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';

    // O foco sempre entra na gaveta (A01): pelo teclado vai pro "Fechar";
    // no clique/toque vai pro titulo, que nao acende anel de foco.
    var alvo = viaKeyboard
      ? cartDrawer.querySelector('.maat-cart-drawer-close')
      : cartDrawer.querySelector('.maat-cart-drawer-title');
    if (alvo) alvo.focus({ preventScroll: true });
  }

  function closeCartDrawer(viaKeyboard) {
    if (!cartDrawer || !cartOverlay) return;
    var focoDentro = cartDrawer.contains(document.activeElement);
    cartDrawer.classList.remove('active');
    cartDrawer.setAttribute('aria-hidden', 'true');
    cartDrawer.setAttribute('inert', '');
    cartOverlay.classList.remove('active');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, cartDrawerSavedScrollY);
    if ((viaKeyboard || focoDentro) && cartDrawerTrigger) cartDrawerTrigger.focus({ preventScroll: true });
  }

  function abrirGavetaComCarrinho(viaKeyboard) {
    return fetchCart()
      .then(function(cart) {
        renderCartDrawer(cart);
        openCartDrawer(viaKeyboard);
      })
      .catch(function() {
        // Sem JS/rede o /cart continua sendo o caminho de sempre.
        window.location.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart';
      });
  }

  if (cartDrawer && cartOverlay) {
    cartDrawer.addEventListener('click', function(e) {
      var btn = e.target.closest ? e.target.closest('button') : null;
      if (!btn) return;

      var item = btn.closest('.maat-cart-drawer-item');
      if (item) {
        var key = item.getAttribute('data-key');
        var valorEl = item.querySelector('.maat-cart-drawer-qty-valor');
        var atual = valorEl ? parseInt(valorEl.textContent, 10) : 1;
        if (btn.getAttribute('data-acao') === 'mais') { changeCartLine(key, atual + 1, item); return; }
        if (btn.getAttribute('data-acao') === 'menos') { changeCartLine(key, Math.max(0, atual - 1), item); return; }
        if (btn.classList.contains('maat-cart-drawer-item-remover')) { changeCartLine(key, 0, item); return; }
        return;
      }

      if (btn.classList.contains('maat-cart-drawer-close') ||
          btn.classList.contains('maat-cart-drawer-continue')) {
        closeCartDrawer(e.detail === 0);
        return;
      }

      if (btn.classList.contains('maat-cart-drawer-checkout')) {
        btn.disabled = true;
        window.location.href = '/checkout';
      }
    });

    cartOverlay.addEventListener('click', function() { closeCartDrawer(false); });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && cartDrawer.classList.contains('active')) {
        closeCartDrawer(true);
      }
    });

    // O icone do header abre a gaveta; o href pro /cart fica como fallback
    // sem JS e para abrir em nova aba.
    var cartIconLink = document.querySelector('.maat-cart-icon');
    if (cartIconLink) {
      cartIconLink.addEventListener('click', function(e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
        e.preventDefault();
        cartDrawerTrigger = cartIconLink;
        abrirGavetaComCarrinho(e.detail === 0);
      });
    }

    // Carrinho flutuante (ADR-0024): aparece so quando o icone do header
    // sai da tela (no celular o header nao acompanha a rolagem). O CSS
    // limita ao celular e o atributo hidden cuida do carrinho vazio.
    var cartFloat = document.querySelector('.maat-cart-float');
    if (cartFloat) {
      cartFloat.addEventListener('click', function(e) {
        cartDrawerTrigger = cartFloat;
        abrirGavetaComCarrinho(e.detail === 0);
      });
      if (cartIconLink && 'IntersectionObserver' in window) {
        new IntersectionObserver(function(entries) {
          cartFloat.classList.toggle('is-visible', !entries[0].isIntersecting);
        }).observe(cartIconLink);
      } else {
        cartFloat.classList.add('is-visible');
      }
    }
  }

  /* ============================================================
     ADD TO CART — AJAX
     ============================================================ */
  // a11y A13: mensagens de status (sucesso, erro) numa regiao role="status".
  // A regiao precisa existir antes da mensagem para o leitor de tela anunciar;
  // a PDP ja traz a sua no Liquid, as demais (home, packs) sao criadas aqui.
  function statusDoForm(form) {
    var el = form.querySelector('.maat-add-cart-status');
    if (!el) {
      el = document.createElement('p');
      el.className = 'maat-add-cart-status visually-hidden';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      form.appendChild(el);
    }
    return el;
  }

  function anunciar(el, msg) {
    if (!el) return;
    // Esvazia antes para repetir o anuncio quando a mensagem e igual a anterior.
    el.textContent = '';
    setTimeout(function() { el.textContent = msg; }, 50);
  }

  document.querySelectorAll('.maat-add-cart-form').forEach(function(form) {
    var statusEl = statusDoForm(form);
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      var btn = form.querySelector('button[type="submit"]');
      var originalHTML = btn ? btn.innerHTML : '';

      // Loading state — desabilitar botao
      if (btn) {
        btn.disabled = true;
        btn.style.opacity = '0.7';
        btn.style.cursor = 'wait';
        btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="animation:spin 0.8s linear infinite"><circle cx="12" cy="12" r="10" stroke-dasharray="31.4 31.4"/></svg> ' + maatEscape(maatT('adding', 'Adicionando...'));
      }

      // D144: todo botao de compra vai direto pro /checkout (ADR-0020), entao funciona como
      // "comprar so isto": esvazia o carrinho antes de adicionar. Sem isso, quem voltava do
      // checkout (do Pix ou do botao normal) e clicava de novo levava o item em dobro.
      // A gaveta (icone do carrinho) continua sendo o lugar de editar o carrinho.
      var formData = new FormData(form);
      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' }
      })
      .then(function(res) {
        if (!res.ok) throw new Error(maatT('unavailable', 'Produto indisponível'));
        return fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
      })
      .then(function(res) {
        if (!res.ok) {
          return res.json().then(function(err) { throw new Error(err.description || maatT('unavailable', 'Produto indispon\u00edvel')); });
        }
        return res.json();
      })
      .then(function(data) {
        anunciar(statusEl, maatT('added', 'Adicionado ao carrinho.'));
        // A gaveta e modal: o leitor de tela pode ignorar regioes fora dela,
        // entao o anuncio vai tambem na regiao viva da gaveta (reteste R5).
        anunciar(document.querySelector('.maat-cart-drawer-live'), maatT('added', 'Adicionado ao carrinho.'));
        if (btn) {
          btn.disabled = false;
          btn.style.opacity = '';
          btn.style.cursor = '';
          btn.classList.add('success');
          btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6L9 17l-5-5"/></svg> ' + maatEscape(maatT('added_button', 'Adicionado!'));
          btn.style.background = '#3D7A2E';
          setTimeout(function() {
            btn.innerHTML = originalHTML;
            btn.style.background = '';
            btn.classList.remove('success');
          }, 2000);
        }
        // ADR-0020 (decisao do Cleber, 02/10): depois de adicionar, vai DIRETO
        // pro /checkout, como na v1.3.0 (ADR-0011). A gaveta deixa de ser etapa
        // da compra e fica so no icone do carrinho do header, onde o cliente
        // edita quantidade (o resumo do checkout no Grow e somente leitura; o
        // checkout tem link de volta pro carrinho). Badge atualizado antes de
        // sair; 400ms pro "Adicionado!" verde aparecer.
        fetchCart().then(updateCartBadge).catch(function() {});
        setTimeout(function() { window.location.href = '/checkout'; }, 400);
      })
      .catch(function(err) {
        console.error('Erro ao adicionar ao carrinho:', err);
        anunciar(statusEl, maatT('add_error', 'Não foi possível adicionar ao carrinho.') + ' ' + (err && err.message ? err.message : maatT('try_again', 'Tenta de novo.')));
        if (btn) {
          btn.disabled = false;
          btn.style.opacity = '';
          btn.style.cursor = '';
          btn.textContent = maatT('error_button', 'Erro. Tenta de novo');
          setTimeout(function() { btn.innerHTML = originalHTML; }, 2000);
        }
      });
    });
  });

  /* Barra de frete gratis por valor (carrinho) REMOVIDA (2026-07-05, ADR-0004): inerte (sem host), obsoleta pela 1a compra. */

  /* ============================================================
     NEWSLETTER — FEEDBACK
     ============================================================ */
  var newsletterForm = document.getElementById('maat-newsletter-form');
  if (newsletterForm) {
    var successMsg = document.querySelector('.maat-newsletter-success');
    var errorMsg = document.querySelector('.maat-newsletter-error');
    var formNote = newsletterForm.querySelector('.form__message');

    if (formNote) {
      if (successMsg) successMsg.style.display = 'block';
      var formFields = newsletterForm.querySelector('.maat-newsletter-form');
      if (formFields) formFields.style.display = 'none';
    }
    if (newsletterForm.querySelector('.errors') && errorMsg) {
      errorMsg.style.display = 'block';
    }
  }

});
